import React from 'react';
import { Link } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  Typography,
  Link as MuiLink,
  Stack,
} from '@mui/material';
import { LoginForm } from './LoginForm';
import { useAuth } from '../../contexts/AuthContext';

export const LoginDialog = () => {
  const { loginDialogOpen, setLoginDialogOpen, setSignupDialogOpen } =
    useAuth();

  return (
    <Dialog
      open={loginDialogOpen}
      onClose={() => setLoginDialogOpen(false)}
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        <LoginForm afterSubmit={() => setLoginDialogOpen(false)} />
      </DialogContent>
      <Stack
        direction="column"
        spacing={1}
        alignItems="center"
        justifyContent="center"
        paddingBottom={2}
      >
        <Stack direction="row" spacing={0.5} justifyContent="center">
          <Typography variant="body2">Don't have an account? </Typography>
          <MuiLink
            component="button"
            onClick={() => {
              setLoginDialogOpen(false);
              setSignupDialogOpen(true);
            }}
          >
            Sign up
          </MuiLink>
        </Stack>
        <Typography variant="body2">
          <Link to="/guests/password/new">Forgot your password?</Link>
        </Typography>
      </Stack>
    </Dialog>
  );
};
